<template>
  <el-dialog
    class="dialog-wrapper values-temperature"
    visible
    show-close
    :close-on-click-modal="false"
    @close="abortInsert"
  >
    <ContentHeader
      slot="title"
      :title="$t('analysesData.valuesTemperatureBulk.title')"
    />
    <div v-loading="apiCallInProgress">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-steps
            :active="stepActive"
            finish-status="success"
            :align-center="true"
          >
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step1')"
            ></el-step>
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step2')"
            ></el-step>
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step3')"
            ></el-step>
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step4')"
            ></el-step>
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step5')"
            ></el-step>
            <el-step
              :title="$t('analysesData.valuesTemperatureBulk.step6')"
            ></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-divider />
      <ValidationObserver
        ref="valuesTemperatureDataForm"
        v-slot="{ handleSubmit, invalid }"
      >
        <el-form
          ref="form"
          @submit.native.prevent
          label-position="top"
        >
          <!-- Step 1 -->
          <el-row
            v-if="stepActive === 0"
            :gutter="20"
          >
            <el-col
              :span="10"
              :offset="7"
            >
              <FormItem
                :label="$t('analysesData.valuesTemperatureBulk.thermostatCode')"
              >
                <el-input
                  ref="QRThermostat"
                  @keyup.enter.native="opValuesMixin.searchThermostat"
                  v-model="thermostat.code"
                />
                <label class="el-form-item__label">
                  {{
                    $t('analysesData.valuesTemperatureBulk.qrScanExplanation')
                  }}
                </label>
              </FormItem>
              <div
                v-if="formData.thermostatId && thermostat.name"
                class="selected-thermostat"
              >
                <p class="selected-thermostat__details">
                  <strong
                    >{{
                      $t('analysesData.valuesTemperatureBulk.thermostatCode')
                    }}:</strong
                  >
                  {{ formData.thermostatId }}
                </p>
                <p class="selected-thermostat__details">
                  <strong
                    >{{
                      $t('analysesData.valuesTemperatureBulk.thermostatName')
                    }}:</strong
                  >
                  {{ thermostat.name }}
                </p>
                <p class="selected-thermostat__details">
                  <strong
                    >{{
                      $t('analysesData.valuesTemperatureBulk.thermostatTemp')
                    }}:</strong
                  >
                  {{ thermostat.temperature }} °C
                </p>
              </div>
            </el-col>
          </el-row>
          <!-- End Step 1 -->

          <!-- Step 2 -->
          <el-row
            v-if="stepActive === 1"
            :gutter="20"
          >
            <el-col
              :span="10"
              :offset="7"
            >
              <FormItem
                :label="$t('analysesData.valuesTemperatureBulk.groupingId')"
              >
                <el-input
                  ref="QRGrouping"
                  @keyup.enter.native="opValuesMixin.searchGrouping"
                  v-model="grouping.code"
                  type="number"
                  class="el-form-input"
                />
                <label class="el-form-item__label">
                  {{
                    $t('analysesData.valuesTemperatureBulk.qrScanExplanation')
                  }}
                </label>
              </FormItem>
            </el-col>
            <el-col :span="24">
              <div class="table-wrapper">
                <el-table
                  class="width-100"
                  :data="sampleGroupingsTableData"
                  border
                >
                  <el-table-column
                    prop="groupingId"
                    :label="$t('filters.grouping')"
                  />
                  <el-table-column
                    prop="samplesCount"
                    :label="$t('filters.samplesCount')"
                    :min-width="30"
                  />
                  <el-table-column
                    :min-width="10"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        :style="{ cursor: 'pointer' }"
                        @click="opValuesMixin.removeGrouping(scope.row)"
                      >
                        <i class="state-icon fas fa-trash" />
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <!-- End Step 2 -->

          <!-- Step 3 -->
          <el-row
            v-if="stepActive === 2"
            :gutter="20"
          >
            <el-col
              :span="10"
              :offset="7"
            >
              <FormItem
                :label="$t('analysesData.valuesTemperatureBulk.analysisCode')"
              >
                <el-input
                  ref="QRAnalysis"
                  @keyup.enter.native="
                    opValuesMixin.searchAnalysis(
                      {
                        thermostatId: formData.thermostatId,
                      },
                      true
                    )
                  "
                  v-model="analysis.code"
                />
                <label class="el-form-item__label">
                  {{
                    $t('analysesData.valuesTemperatureBulk.qrScanExplanation')
                  }}
                </label>
              </FormItem>
            </el-col>
            <el-col :span="24">
              <div class="table-wrapper">
                <el-table
                  class="width-100"
                  :data="selectedAnalysesTableData"
                  border
                >
                  <el-table-column
                    prop="code"
                    :label="$t('filters.analysisCode')"
                  />
                  <el-table-column
                    prop="description"
                    :label="$t('filters.analysisDescription')"
                  />
                  <el-table-column
                    :min-width="10"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        :style="{ cursor: 'pointer' }"
                        @click="opValuesMixin.removeAnalysis(scope.row)"
                      >
                        <i class="state-icon fas fa-trash" />
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <!-- End Step 3 -->

          <!-- Step 4 -->
          <el-row
            v-if="stepActive === 3"
            :gutter="20"
          >
            <el-col :span="24">
              <div class="table-wrapper">
                <el-table
                  class="width-100"
                  :data="samplesTableData"
                  border
                >
                  <el-table-column
                    label=""
                    align="center"
                    :key="refreshHeaderCheckbox"
                    :min-width="15"
                  >
                    <template slot-scope="scope">
                      <el-checkbox
                        :value="checkBoxChecked(scope.row, 'child')"
                        :indeterminate="
                          checkBoxIndeterminate(scope.row, 'child')
                        "
                        @change="
                          (value) =>
                            handleSelectionChange(scope.row, value, 'child')
                        "
                      />
                    </template>
                    <template slot="header">
                      <el-checkbox
                        :value="checkBoxChecked(null, 'header')"
                        :indeterminate="checkBoxIndeterminate(null, 'header')"
                        @change="
                          (value) =>
                            handleSelectionChange(null, value, 'header')
                        "
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="labSampleId"
                    :label="$t('filters.labSampleId')"
                    :min-width="30"
                  />
                  <el-table-column
                    prop="groupingId"
                    :label="$t('filters.grouping')"
                    :min-width="30"
                  />
                  <el-table-column
                    prop="labSampleCode"
                    :label="$t('filters.labSampleCode')"
                    :min-width="50"
                  />
                  <el-table-column
                    prop="productName"
                    :label="$t('filters.productName')"
                    :min-width="50"
                  />
                  <el-table-column
                    prop="openTrails"
                    :label="$t('filters.openTrails')"
                    :min-width="30"
                  />
                </el-table>
              </div>
            </el-col>
          </el-row>
          <!-- End Step 4  -->

          <!-- Step 5 -->
          <el-row
            v-if="stepActive === 4"
            :gutter="20"
          >
            <el-col
              :span="10"
              :offset="7"
            >
              <FormItem
                v-if="shouldShowStartDateInput"
                rules="required"
                :label="$t('analysesData.valuesTemperatureBulk.startDateTime')"
              >
                <el-date-picker
                  ref="startDatePicker"
                  v-model="traceDateTime.startDateTime"
                  format="dd-MM-yyyy HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  placeholder=""
                  :picker-options="{ disabledDate: isDateDisabled }"
                  @focus="observeNowButton('startDatePicker', 'startDateTime')"
                  @change="handleStartDate"
                />
              </FormItem>
              <FormItem
                v-if="shouldShowEndDateInput"
                rules="required"
                :label="$t('analysesData.valuesTemperatureBulk.endDateTime')"
              >
                <el-date-picker
                  ref="endDatePicker"
                  v-model="traceDateTime.endDateTime"
                  format="dd-MM-yyyy HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  placeholder=""
                  :disabled="!traceDateTime.startDateTime"
                  :picker-options="{ disabledDate: isEndDateDisabled }"
                  @focus="observeNowButton('endDatePicker', 'endDateTime')"
                  @change="handleEndDate"
                />
              </FormItem>
            </el-col>
          </el-row>
          <!-- End Step 5 -->

          <!-- Step 6 -->
          <el-row
            v-if="stepActive === 5"
            :gutter="20"
          >
            <el-col :span="24">
              <p class="bulk-temperature-summary">
                {{
                  $t('analysesData.valuesTemperatureBulk.summaryText', {
                    thermostatCode: thermostat.name,
                    thermostatTemperature: `${thermostat.temperature} °C`,
                    analysisCodes,
                  })
                }}
              </p>
            </el-col>
            <el-col :span="24">
              <div class="table-wrapper">
                <el-table
                  class="width-100"
                  :data="selectedSamples"
                  border
                >
                  <el-table-column
                    prop="labSampleId"
                    :label="$t('filters.labSampleId')"
                    :min-width="30"
                  />
                  <el-table-column
                    prop="groupingId"
                    :label="$t('filters.grouping')"
                    :min-width="30"
                  />
                  <el-table-column
                    prop="labSampleCode"
                    :label="$t('filters.labSampleCode')"
                    :min-width="50"
                  />
                  <el-table-column
                    prop="productName"
                    :label="$t('filters.productName')"
                    :min-width="50"
                  />
                </el-table>
              </div>
            </el-col>
          </el-row>
          <!-- End Step 6 -->

          <FormButtons>
            <el-button
              type="secondary"
              @click.prevent="abortInsert"
            >
              {{ $t('global.cancel') }}
            </el-button>
            <el-button
              type="secondary"
              v-if="stepActive > 0 && stepActive <= 5"
              @click.prevent="prevStep"
            >
              {{ $t('global.prev') }}
            </el-button>
            <el-button
              type="primary"
              :disabled="invalid || !formData.thermostatId"
              :loading="apiCallInProgress"
              v-if="stepActive < 5"
              @click.prevent="nextStep"
            >
              {{ $t('global.next') }}
            </el-button>

            <el-button
              type="primary"
              :disabled="
                invalid ||
                selectedAnalysesTableData.length === 0 ||
                apiCallInProgress ||
                bulkExecuted
              "
              :loading="apiCallInProgress"
              @click.prevent="handleSubmit(closeTraces)"
              v-if="stepActive === 5 && shouldShowEndDateInput"
            >
              {{ $t('analysesData.valuesTemperatureBulk.closeTrace') }}
            </el-button>
            <el-button
              type="primary"
              :disabled="
                invalid ||
                selectedAnalysesTableData.length === 0 ||
                apiCallInProgress ||
                bulkExecuted
              "
              :loading="apiCallInProgress"
              @click.prevent="handleSubmit(insertValues)"
              v-if="stepActive === 5 && shouldShowStartDateInput"
            >
              {{ $t('analysesData.valuesTemperatureBulk.createTrace') }}
            </el-button>
          </FormButtons>
        </el-form>
      </ValidationObserver>
    </div>

    <BulkCall
      ref="createTraceBulk"
      class="values-temperature__bulk"
      :function="insertValue"
      :arguments="analysisIds"
      @completed="bulkCompleted"
    />

    <BulkCall
      ref="closeTraceBulk"
      class="values-temperature__bulk"
      :function="closeTrace"
      :arguments="analysisIds"
      @completed="bulkCompleted"
    />

    <el-dialog
      class="dialog-wrapper thermostat-warning-dialog"
      :visible="thermostatWarningVisible"
      :close-on-click-modal="false"
      :before-close="cancelCloseTraces"
      append-to-body
    >
      <ContentHeader
        slot="title"
        :title="
          $t('analysesData.valuesTemperatureBulk.thermostatWarning.title')
        "
      />
      <el-form
        label-position="top"
        @submit.native.prevent
      >
        <el-alert
          type="warning"
          :closable="false"
          show-icon
          :title="
            $t('analysesData.valuesTemperatureBulk.thermostatWarning.message')
          "
        />
        <p class="thermostat-warning-dialog__selected">
          <strong>
            {{
              $t(
                'analysesData.valuesTemperatureBulk.thermostatWarning.selectedThermostat'
              )
            }}:
          </strong>
          {{ thermostat.name }}
        </p>
        <div class="table-wrapper">
          <el-table
            class="width-100"
            :data="thermostatMismatches"
            row-key="labSampleAnalysisId"
            border
          >
            <el-table-column
              prop="labSampleCode"
              :label="
                $t(
                  'analysesData.valuesTemperatureBulk.thermostatWarning.labSampleCode'
                )
              "
            />
            <el-table-column
              prop="analysisCode"
              :label="$t('analysesData.valuesTemperatureBulk.analysisCode')"
            />
            <el-table-column
              prop="openingThermostat"
              :label="
                $t(
                  'analysesData.valuesTemperatureBulk.thermostatWarning.openingThermostat'
                )
              "
            />
          </el-table>
        </div>
        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="cancelCloseTraces"
          >
            {{ $t('global.cancel') }}
          </el-button>
          <el-button
            type="primary"
            @click.prevent="confirmCloseTraces"
          >
            {{
              $t('analysesData.valuesTemperatureBulk.thermostatWarning.proceed')
            }}
          </el-button>
        </FormButtons>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import { thermostatsApi } from '@/api';

  import insertValuesTemperatureMixin from '@/mixins/insertValuesTemperatureBulk';

  import FormItem from '@/components/FormItem.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import BulkCall from '@/components/BulkCall.vue';

  const initialData = {
    thermostatId: null,
  };

  const TRACE_MODES = {
    OPEN: 'open',
    CLOSE: 'close',
  };

  export default {
    name: 'InsertValuesTemperatureBulk',
    components: {
      FormItem,
      ContentHeader,
      FormButtons,
      BulkCall,
    },
    data() {
      return {
        stepActive: 0,
        apiCallInProgress: false,
        // A bulk call ended with errors: something may have been written
        dataChanged: false,
        // Locks the step 5 buttons after a bulk call with errors: a retry must
        // start from the traces reloaded in step 2 -> 3, not resend the same ones
        bulkExecuted: false,
        formData: { ...initialData },
        thermostat: {
          code: null,
          name: null,
          temperature: null,
        },
        thermostatCode: null,
        grouping: {
          code: null,
        },
        sampleIdsWithGrouping: {},
        loading: false,
        analysis: {
          code: null,
        },
        sampleAnalyses: [],
        selectedAnalyses: {},
        labSampleAnalysisIds: [],
        traceDateTime: {
          startDateTime: null,
          endDateTime: null,
        },
        shouldShowStartDateInput: false,
        shouldShowEndDateInput: false,
        // Mode of the last step 4 -> 5: the step 5 date is kept only while it does not change
        lastTraceMode: null,
        thermostatWarningVisible: false,
        temperatureTrails: [],
        temperatureTrailsByLabSample: [],
        selectedSamples: [],
        refreshHeaderCheckbox: 0,
      };
    },
    computed: {
      sampleGroupingsTableData() {
        return Object.keys(this.sampleIdsWithGrouping).map((key) => ({
          groupingId: key,
          samplesCount: this.sampleIdsWithGrouping[key].length,
        }));
      },
      selectedAnalysesTableData() {
        return Object.keys(this.selectedAnalyses).map((key) => ({
          id: key,
          ...this.selectedAnalyses[key],
        }));
      },
      sampleIdsFlattened() {
        return Array.from(
          new Set(
            Object.keys(this.sampleIdsWithGrouping).flatMap((key) =>
              this.sampleIdsWithGrouping[key].map((s) => s.id)
            )
          )
        );
      },
      samplesTableData() {
        const tableData =
          this.labSampleAnalysisIds.map((value) => ({
            labSampleId: value.labSampleId,
            labSampleCode: value.sampleValues.labSampleCode || '-',
            labSampleAnalysisId: value.labSampleAnalysisId,
            analysisId: value.analysisId,
            analysisCode: value.analysisCode,
            groupingId: value.sampleValues.groupingId,
            productName: value.sampleValues.productName,
            openTrails:
              (
                this.temperatureTrailsByLabSample.find(
                  (t) => t.labSampleId === value.labSampleId
                ) || {}
              ).openTrails || 0,
          })) || [];
        return tableData.reduce((acc, item) => {
          const duplicateLabSampleCode = acc.find(
            (val) => val.labSampleCode === item.labSampleCode
          );
          if (!duplicateLabSampleCode) {
            return [...acc, item];
          }
          return acc;
        }, []);
      },
      // sampleSummaryTableData() {
      //   return Object.keys(this.sampleIdsWithGrouping).flatMap((key) =>
      //     this.sampleIdsWithGrouping[key]
      //       .map((s) => ({
      //         labSampleId: s.id,
      //         groupingId: key,
      //         labSampleCode: s.labSampleCode || '-',
      //         productName: s.productName,
      //       }))
      //       .filter((s) =>
      //         this.selectedSamples.some(
      //           (selected) => selected.labSampleId === s.labSampleId
      //         )
      //       )
      //   );
      // },
      analysisIds() {
        const labSampleCodes = this.selectedSamples.map((s) => s.labSampleCode);
        const labSampleAnalysisFiltered = this.labSampleAnalysisIds.filter(
          (item) => labSampleCodes.includes(item.sampleValues.labSampleCode)
        );
        const labSampleAnalysisIds = labSampleAnalysisFiltered.map(
          (s) => s.labSampleAnalysisId
        );
        if (this.shouldShowEndDateInput) {
          const temperatureTrailsLabSampleAnalysisId =
            this.temperatureTrails.map((t) => t.labSampleAnalysisId);
          labSampleAnalysisIds.filter((id) =>
            temperatureTrailsLabSampleAnalysisId.includes(id)
          );
        }
        const set = new Set(labSampleAnalysisIds);
        const result = [];
        Array.from(set).forEach((id) => result.push([id]));

        return result;
      },
      closingTrails() {
        const ids = new Set(this.analysisIds.flat());
        return this.temperatureTrails.filter((trail) =>
          ids.has(trail.labSampleAnalysisId)
        );
      },
      thermostatMismatches() {
        return this.closingTrails
          .filter((trail) => trail.thermostatId !== this.formData.thermostatId)
          .map((trail) => {
            const { sampleValues, analysisCode } =
              this.labSampleAnalysisIds.find(
                (item) => item.labSampleAnalysisId === trail.labSampleAnalysisId
              );
            return {
              labSampleAnalysisId: trail.labSampleAnalysisId,
              labSampleCode: sampleValues.labSampleCode,
              analysisCode,
              openingThermostat: trail.thermostat.name,
            };
          });
      },
      maxAcceptedAt() {
        const samples = [];
        Object.values(this.sampleIdsWithGrouping).forEach((grouping) => {
          grouping.forEach((sample) => {
            samples.push(sample);
          });
        });
        return samples.reduce((acc, sample) => {
          if (sample.acceptedAt) {
            const current = sample.acceptedAt;
            if (!acc) {
              return current;
            }
            return current > acc ? current : acc;
          }
          return acc;
        }, undefined);
      },
      analysisCodes() {
        const codes = this.selectedSamples.map((s) => s.analysisCode);
        return codes
          .filter((item, index) => codes.indexOf(item) === index)
          .join(', ');
      },
    },
    created() {
      this.opValuesMixin = insertValuesTemperatureMixin(this);
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.QRThermostat.focus();
      });
      this.observeNowButton('startDatePicker', 'startDateTime');
      this.observeNowButton('endDatePicker', 'endDateTime');
    },
    methods: {
      observeNowButton(refName, modelKey) {
        this.$nextTick(() => {
          // Attendi il rendering del picker panel
          setTimeout(() => {
            const picker = this.$refs[refName];
            if (!picker || !picker.pickerVisible) return;

            const panel = document.querySelectorAll('.el-picker-panel__footer');
            if (!panel.length) return;
            const footer = panel[panel.length - 1];
            const nowBtn = Array.from(
              footer.querySelectorAll('.el-picker-panel__link-btn')
            ).find(
              (btn) =>
                btn.innerText.toLowerCase().includes('ora') ||
                btn.innerText.toLowerCase().includes('now')
            );

            if (!nowBtn) return;

            nowBtn.addEventListener(
              'click',
              () => {
                this.traceDateTime[modelKey] = moment(new Date()).toDate();

                this.$nextTick(() => {
                  if (picker.pickerVisible) {
                    picker.pickerVisible = false;
                  }
                });
              },
              { once: true }
            );
          }, 100);
        });
      },
      abortInsert() {
        this.$emit('dialogClose', {
          success: this.apiCallInProgress || this.dataChanged,
        });
      },
      focusInputs() {
        this.$nextTick(() => {
          if (this.$refs.QRThermostat) this.$refs.QRThermostat.focus();
          if (this.$refs.QRGrouping) this.$refs.QRGrouping.focus();
          if (this.$refs.QRAnalysis) this.$refs.QRAnalysis.focus();
        });
      },
      prevStep() {
        this.stepActive -= 1;
        if (this.stepActive < 0) {
          this.stepActive = 0;
        }
        this.focusInputs();
      },
      async nextStep() {
        // Handle the heavy operations step (2 -> 3)
        if (this.stepActive + 1 === 3) {
          this.apiCallInProgress = true;
          try {
            await this.opValuesMixin.recomputeLabSampleAnalysisIds();
            await this.opValuesMixin.getTemperatureTrails();
            // Fresh traces: step 5 may send again
            this.bulkExecuted = false;
          } catch (error) {
            this.$notify({
              showClose: true,
              type: 'error',
              message: this.$t('global.error'),
            });
            return; // Don't proceed to next step if there's an error
          } finally {
            this.apiCallInProgress = false;
          }
        }

        if (this.stepActive + 1 === 4) {
          if (!this.checkSelectedSamples()) return;
        }

        if (this.stepActive + 1 === 5 && this.shouldShowEndDateInput) {
          if (!this.checkEndDateTime()) return;
        }

        this.stepActive += 1;

        if (this.stepActive === 2) {
          this.apiCallInProgress = true;
          try {
            await this.opValuesMixin.getSampleAnalysesGrouped();
          } catch (error) {
            this.$notify({
              showClose: true,
              type: 'error',
              message: this.$t('global.error'),
            });
          } finally {
            this.apiCallInProgress = false;
          }
        }

        if (this.stepActive > 5) {
          this.stepActive = 5;
        }

        this.focusInputs();
      },
      checkTemperatureTrails() {
        if (this.temperatureTrails.length === 0) return true;
        let startDate = null;
        let endDate = null;
        return this.temperatureTrails.every((trail) => {
          if (startDate == null) {
            startDate = trail.startedAt;
          }
          if (trail.startedAt?.valueOf() !== startDate?.valueOf()) {
            return false;
          }
          if (endDate == null) {
            endDate = trail.endedAt;
          }
          if (trail.endedAt?.valueOf() !== endDate?.valueOf()) {
            return false;
          }
          return true;
        });
      },
      insertValue(labSampleAnalysisId) {
        return thermostatsApi.createTemperatureTrail({
          thermostatId: this.formData.thermostatId,
          labSampleAnalysisId,
          startedAt: moment(this.traceDateTime.startDateTime).toDate(),
          endedAt: this.traceDateTime.endDateTime
            ? moment(this.traceDateTime.endDateTime).toDate()
            : null,
        });
      },
      insertValues() {
        this.apiCallInProgress = true;
        this.$refs.createTraceBulk.run();
      },
      closeTrace(labSampleAnalysisId) {
        return thermostatsApi.closeTemperatureTrail(labSampleAnalysisId, {
          thermostatId: this.formData.thermostatId,
          endedAt: moment(this.traceDateTime.endDateTime).toDate(),
        });
      },
      closeTraces() {
        if (this.thermostatMismatches.length > 0) {
          this.thermostatWarningVisible = true;
          return;
        }
        this.runCloseTraces();
      },
      runCloseTraces() {
        this.apiCallInProgress = true;
        this.$refs.closeTraceBulk.run();
      },
      confirmCloseTraces() {
        this.thermostatWarningVisible = false;
        this.runCloseTraces();
      },
      cancelCloseTraces() {
        this.thermostatWarningVisible = false;
        this.stepActive = 0;
        this.focusInputs();
      },
      updateTraceMode(mode) {
        if (this.lastTraceMode && mode !== this.lastTraceMode) {
          // Closing keeps the start reloaded from the trail
          this.traceDateTime.endDateTime = null;
          if (mode === TRACE_MODES.OPEN)
            this.traceDateTime.startDateTime = null;
        }
        this.lastTraceMode = mode;
      },
      checkEndDateTime() {
        const end = moment(this.traceDateTime.endDateTime);
        const startsAfterEnd = this.closingTrails
          .map((trail) => moment(trail.startedAt))
          .filter((startedAt) => end.isBefore(startedAt));
        if (startsAfterEnd.length === 0) return true;
        this.$notify({
          showClose: true,
          type: 'error',
          message: this.$t(
            'analysesData.valuesTemperatureBulk.endBeforeTrailStart',
            { startedAt: moment.max(startsAfterEnd).format('DD-MM-YYYY HH:mm') }
          ),
        });
        return false;
      },
      bulkCompleted(errors) {
        if (errors) {
          // The results stay on screen: hand the buttons back, and remember
          // that the traces sent before the failing ones were written
          this.apiCallInProgress = false;
          this.dataChanged = true;
          this.bulkExecuted = true;
          return;
        }
        this.$emit('dialogClose', { success: true });
        this.$notify({
          showClose: true,
          type: 'success',
          message: this.$t('global.success'),
        });
      },
      isDateDisabled(date) {
        const today = moment.utc().startOf('day').toDate();
        if (date > today) return true;

        if (date < moment(this.maxAcceptedAt).startOf('day').toDate())
          return true;

        return false;
      },
      isEndDateDisabled(date) {
        const today = moment.utc().startOf('day').toDate();
        if (date > today) return true;

        const startDateTime = moment(this.traceDateTime.startDateTime)
          .startOf('day')
          .toDate();
        if (date < startDateTime) return true;

        return false;
      },
      handleStartDate(value) {
        if (new Date(value) < new Date(this.maxAcceptedAt)) {
          this.traceDateTime.startDateTime = moment(
            new Date(this.maxAcceptedAt)
          ).toDate();
        }
      },
      handleEndDate(value) {
        if (new Date(value) > new Date()) {
          this.traceDateTime.endDateTime = moment(new Date()).toDate();
        }
      },
      handleSelectionChange(row, value, type) {
        switch (type) {
          case 'header':
            if (value) {
              // Select all - only add items not already selected
              this.samplesTableData.forEach((sample) => {
                const alreadySelected = this.selectedSamples.some(
                  (s) => s.labSampleId === sample.labSampleId
                );
                if (!alreadySelected) {
                  this.selectedSamples.push(sample);
                }
              });
            } else {
              this.selectedSamples = [];
            }
            break;
          case 'child':
          default:
            if (value) {
              // Add only if not already selected (prevent duplicates upfront)
              const alreadySelected = this.selectedSamples.some(
                (s) => s.labSampleId === row.labSampleId
              );
              if (!alreadySelected) {
                this.selectedSamples.push(row);
              }
            } else {
              this.selectedSamples = this.selectedSamples.filter(
                (r) => r.labSampleId !== row.labSampleId
              );
            }
            break;
        }
        this.refreshHeaderCheckbox += 1; // Force refresh checkbox column
      },
      checkBoxChecked(row, type) {
        switch (type) {
          case 'header':
            return (
              this.selectedSamples.length === this.samplesTableData.length &&
              this.selectedSamples.length !== 0
            );
          case 'child':
          default:
            // Use ID comparison instead of object reference (more reliable)
            return this.selectedSamples.some(
              (s) => s.labSampleId === row.labSampleId
            );
        }
      },
      checkBoxIndeterminate(row, type) {
        switch (type) {
          case 'header':
            return (
              this.selectedSamples.length > 0 &&
              this.selectedSamples.length < this.samplesTableData.length
            );
          case 'child':
          default:
            return false;
        }
      },
      checkSelectedSamples() {
        if (this.selectedSamples.length === 0) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: this.$t(
              'analysesData.valuesTemperatureBulk.invalidSamples'
            ),
          });
          return false;
        }
        const sampleWithoutTrails = this.selectedSamples.filter(
          (s) => s.openTrails === 0
        );
        const sampleWithTrails = this.selectedSamples.filter(
          (s) => s.openTrails !== 0
        );
        if (sampleWithoutTrails.length === this.selectedSamples.length) {
          this.shouldShowStartDateInput = true;
          this.shouldShowEndDateInput = false;
          this.updateTraceMode(TRACE_MODES.OPEN);
          return true;
        }
        if (sampleWithTrails.length === this.selectedSamples.length) {
          this.shouldShowStartDateInput = false;
          this.shouldShowEndDateInput = true;
          this.updateTraceMode(TRACE_MODES.CLOSE);
          return true;
        }
        this.$notify({
          showClose: true,
          type: 'error',
          message: this.$t(
            'analysesData.valuesTemperatureBulk.invalidSamplesSelection'
          ),
        });
        return false;
      },
    },
  };
</script>

<style lang="scss">
  .values-temperature {
    .el-dialog {
      width: 50%;
    }

    .el-step {
      word-break: break-word;
    }

    .selected-thermostat {
      &__details {
        padding-bottom: 0.5rem;
        font-size: 1rem;
      }
    }

    .el-form-item__label {
      word-break: initial;
      line-height: 1.4;
    }

    .bulk-temperature-summary {
      word-break: initial;
      margin-bottom: 1rem;
    }

    // Only when the progress or the results are shown: the idle BulkCall is an empty div
    &__bulk > .el-row:first-child {
      margin-top: 1.5rem;
    }

    // Hide arrows from number inputs
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    .el-form-input input[type='number'] {
      -moz-appearance: textfield;
    }
  }

  .thermostat-warning-dialog {
    .el-dialog {
      width: 50%;
    }

    &__selected {
      margin: 1rem 0;
      font-size: 1rem;
    }
  }
</style>
